export default function onlyPosixErrors(errors = []) {
  // if no errors, return true anyways
  // if errors, test to see if all of them are posix, if so, return true
  return (errors && errors.length)
    ? errors.filter(error => error.field.match(/^Posix/)).length === errors.length
    : true;
}
